import { AskRequest, AskResponse, ChatRequest, LikeRequest, ChatTimer } from "./models";
import i18n from '@/i18n/config';

const SERVER_IP = import.meta.env.PROD ? import.meta.env.VITE_API_SERVER_IP_PROD : import.meta.env.VITE_API_SERVER_IP_DEV;

let currentLanguageCode = "pt";

function getErrorMessages() {
    return {
      serverIssue: i18n.t('settings.errorServer'),
      noResponse: i18n.t('settings.errorResponse')
    };
  }

export async function setLanguageApi(languageCode: string): Promise<null> {
    currentLanguageCode = languageCode;
    i18n.changeLanguage(languageCode);
    return null;
}

function getHeaders() {
    return {
        "Content-Type": "application/json",
        "x-selected-language": currentLanguageCode
    };
}

const SUCCESS_STATUS_RANGE = 299;
const UNKNOWN_ERROR = "Unknown error";


async function fetchApi(endpoint: string, body: object, ): Promise<any> {
    const response = await fetch(`${SERVER_IP}/${endpoint}`, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(body)
    });

    const parsedResponse = await response.json();
    if (response.status > SUCCESS_STATUS_RANGE || !response.ok) {
        throw Error(parsedResponse.error || UNKNOWN_ERROR);
    }

    return parsedResponse;
}

export async function askApi(options: AskRequest): Promise<AskResponse> {
    return fetchApi("ask", {
        question: options.question,
        approach: options.approach,
        overrides: {
            quantile: options.overrides?.quantile,
            suggest_followup_questions: options.overrides?.suggestFollowupQuestions
        }
    });
}

export async function chatApi(options: ChatRequest): Promise<AskResponse> {
    options.language = currentLanguageCode;
    return fetchApi("chat", options);
}

export async function chatApiStream(options: ChatRequest, handleStream: (value: string, dataFound: boolean) => boolean, resetStream: (message?: string) => void): Promise<void> {
    let dataFound = false;
    const { serverIssue, noResponse } = getErrorMessages();

    try {
        const response = await fetch(`${SERVER_IP}/achat_stream`, {
            method: "POST",
            headers: getHeaders(),
            body: JSON.stringify(options)
        });

        if (response.status > SUCCESS_STATUS_RANGE) {
            throw Error(response.status.toString());
        }

        const reader = response?.body?.pipeThrough(new TextDecoderStream()).getReader();

        while (true) {
            const { value, done } = reader ? await reader.read() : { value: "", done: true };
            if (done) {
                resetStream(dataFound ? undefined : noResponse);
                break;
            }

            dataFound = handleStream(value, dataFound);
        }
    } catch (e) {
        console.error("error", e);
        console.error("error", e);
        resetStream(serverIssue);
    }
}

export async function likeApi(options: LikeRequest): Promise<null> {
    return fetchApi("like", {
        conversation_id: options.conversation_id,
        iteration_id: options.iteration_id,
        like: options.like,
        reason: options.reason
    });
}

export async function statApi(options: ChatTimer, lastIterationID: string, conversationID: string): Promise<null> {
    return fetchApi("stats", { ...options, conversation_id: conversationID, iteration_id: lastIterationID });
}
